import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";

import {ReactComponent as Check} from "../../assets/check.svg";
import {ReactComponent as Remove} from "../../assets/remove.svg";


const ContentWrapper = styled.div`

width: 100%;
  
`;

function CustomerDocumentTableCell(props) {
    const {hasDocument} = props;

    return (
        <ContentWrapper>
            {hasDocument ? <Check/> : <Remove/>}
        </ContentWrapper>
    );
}

CustomerDocumentTableCell.propTypes = {
    hasDocument: PropTypes.bool.isRequired
};
CustomerDocumentTableCell.defaultProps = {};

export default CustomerDocumentTableCell;
